module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.87f599af.png";